"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bookingOfferByOperatorRootSaga;
exports.passportsMapper = void 0;
var _effects = require("redux-saga/effects");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/services/selectors");
var _ramda = require("ramda");
var _actions = require("../../../../../../../bus/ui/actions");
var _localization = _interopRequireDefault(require("../../../../../../../localization"));
var _api = require("../../../../../../../helpers/api");
var _config = require("../../../../../../../services/config");
var _selectors3 = require("../../../../../../../modalDispatcher/store/selectors");
var _helpers = require("../../../store/helpers");
var _selectors4 = require("../../../store/selectors");
var _actions2 = require("../../../store/actions");
var _BookingServices = require("../../BookingServices");
var _BookingResultModal = require("../components/BookingResultModal");
var _constants = require("../constants");
var _actions3 = require("./actions");
var _constants2 = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(applyExternalActiveBookingServices),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(onShowBookingModal),
  _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(bookingOfferByOperatorRootSaga);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
var passportsMapper = exports.passportsMapper = (0, _ramda.map)((0, _ramda.applySpec)({
  sex: (0, _ramda.pipe)((0, _ramda.prop)('sex'), (0, _ramda.cond)([[(0, _ramda.equals)(_constants.SEX_TYPES.MRS.value), (0, _ramda.always)('female')], [(0, _ramda.equals)(_constants.SEX_TYPES.CHILD.value), (0, _ramda.always)('child')], [_ramda.T, (0, _ramda.always)('male')]])),
  firstName: (0, _ramda.prop)('name'),
  lastName: (0, _ramda.prop)('surname'),
  born: (0, _ramda.prop)('birthday'),
  passportData: (0, _ramda.prop)('passport'),
  passportValid: (0, _ramda.prop)('passportExpireDate'),
  passportGivenorg: (0, _ramda.propOr)('', 'passportIssued'),
  passportGiven: (0, _ramda.prop)('passportGivenDate'),
  nationalityID: (0, _ramda.prop)('citizenship')
}));
function bookingOfferByOperatorSaga(_ref) {
  var _ref$payload = _ref.payload,
    values = _ref$payload.values,
    queryID = _ref$payload.queryID;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var transport, offer, hotel, activeFlights, query, activeBookingServices, activeIntegrationServices, recalculatedPrice, isPromotionalBookingOffer, _call, _yield, id, viewLink, bookingsLink;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          transport = (0, _config.getOnBookingOfferByOperator)();
          if (transport) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          _context.next = 5;
          return (0, _effects.put)((0, _actions.register)(_constants2.BOOKING_OFFER_BY_OPERATOR_UI, {
            loading: true
          }));
        case 5:
          _context.next = 7;
          return (0, _effects.select)(_selectors4.getBootstrapOffer);
        case 7:
          offer = _context.sent;
          _context.next = 10;
          return (0, _effects.select)(_selectors4.getBootstrapHotel);
        case 10:
          hotel = _context.sent;
          _context.next = 13;
          return (0, _effects.select)(_selectors4.getActiveFlights);
        case 13:
          activeFlights = _context.sent;
          _context.next = 16;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQuery)(state, {
              queryID: queryID
            });
          });
        case 16:
          query = _context.sent;
          _context.next = 19;
          return (0, _effects.select)(function (state) {
            return (0, _BookingServices.getActiveBookingServices)(state, {
              currency: query.get(_fn.QUERY_PARAMS.CURRENCY),
              offerID: offer.id
            });
          });
        case 19:
          activeBookingServices = _context.sent;
          _context.next = 22;
          return (0, _effects.select)(_selectors4.getSelectedIntegrationServices);
        case 22:
          activeIntegrationServices = _context.sent;
          _context.next = 25;
          return (0, _effects.select)(_BookingServices.getRecalculatedPriceEntity);
        case 25:
          recalculatedPrice = _context.sent;
          isPromotionalBookingOffer = (0, _helpers.getIsPromotionalBookingOffer)(offer, hotel, query.get(_fn.QUERY_PARAMS.CURRENCY));
          _context.prev = 27;
          _context.next = 30;
          return (_call = (0, _effects.call)(transport, values, offer, hotel, query.toJS(), activeFlights, activeBookingServices, recalculatedPrice, activeIntegrationServices, {
            isPromotionalBookingOffer: isPromotionalBookingOffer
          })) !== null && _call !== void 0 ? _call : {};
        case 30:
          _yield = _context.sent;
          id = _yield.id;
          viewLink = _yield.viewLink;
          bookingsLink = _yield.bookingsLink;
          _context.next = 36;
          return (0, _effects.put)((0, _actions2.setIsShowBookingForOperatorForm)(false));
        case 36:
          if (!id) {
            _context.next = 39;
            break;
          }
          _context.next = 39;
          return (0, _effects.put)((0, _actions3.setBookingConfirmation)({
            id: id,
            viewLink: viewLink,
            bookingsLink: bookingsLink
          }));
        case 39:
          _context.next = 45;
          break;
        case 41:
          _context.prev = 41;
          _context.t0 = _context["catch"](27);
          _context.next = 45;
          return (0, _effects.put)((0, _actions.update)(_constants2.BOOKING_OFFER_BY_OPERATOR_UI, {
            error: true,
            message: " ".concat(_localization.default.t('BOOKING_FORM_BY_OPERATOR:BOOKING_ERROR'), ", ").concat(_context.t0.message)
          }));
        case 45:
          _context.prev = 45;
          _context.next = 48;
          return (0, _effects.put)((0, _actions.update)(_constants2.BOOKING_OFFER_BY_OPERATOR_UI, {
            loading: false,
            completed: true
          }));
        case 48:
          return _context.finish(45);
        case 49:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[27, 41, 45, 49]]);
  })();
}
function applyExternalActiveBookingServices(queryID, offerID, currencyCode, bookingEntity) {
  var shouldShowBookingServices;
  return _regeneratorRuntime().wrap(function applyExternalActiveBookingServices$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return (0, _effects.select)(function (state) {
          var bookingServices = (0, _selectors2.getBookingServicesByOffer)(state, {
            currency: currencyCode,
            offerID: offerID
          });
          return (0, _ramda.isEmpty)(bookingServices);
        });
      case 2:
        shouldShowBookingServices = _context2.sent;
        if (!shouldShowBookingServices) {
          _context2.next = 8;
          break;
        }
        _context2.next = 6;
        return (0, _effects.put)((0, _BookingServices.showBookingServices)(offerID, queryID));
      case 6:
        _context2.next = 8;
        return (0, _effects.take)(function (action) {
          return (0, _ramda.and)((0, _ramda.equals)(action.type, _actions.update.toString()), (0, _ramda.equals)((0, _ramda.prop)('key', action.payload), _BookingServices.FETCH_BOOKING_SERVICES_DATA));
        });
      case 8:
        _context2.next = 10;
        return (0, _effects.put)((0, _BookingServices.recalculateOfferPrice)(offerID, queryID, bookingEntity));
      case 10:
        _context2.next = 12;
        return (0, _effects.take)(function (action) {
          return (0, _ramda.and)((0, _ramda.equals)(action.type, _actions.update.toString()), (0, _ramda.equals)((0, _ramda.prop)('key', action.payload), _BookingServices.RECALCULCATE_OFFER_PRICE));
        });
      case 12:
      case "end":
        return _context2.stop();
    }
  }, _marked);
}
function onShowBookingModal(bookingEntity, queryID) {
  return _regeneratorRuntime().wrap(function onShowBookingModal$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return (0, _effects.put)((0, _BookingResultModal.showBookingResultModal)(function (dispatch) {
          dispatch((0, _actions3.setBookingConfirmation)(null));
        }, {
          queryID: queryID
        }, {
          onConfirmBooking: function onConfirmBooking(dispatch) {
            dispatch((0, _actions2.bookingOfferByOperator)(bookingEntity, queryID));
          }
        }));
      case 2:
      case "end":
        return _context3.stop();
    }
  }, _marked2);
}
function onStartBookingSaga(_ref2) {
  var _ref2$payload = _ref2.payload,
    bookingEntity = _ref2$payload.bookingEntity,
    queryID = _ref2$payload.queryID;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var offer, _yield$select, hasOwnBookingServices, currencyCode, isNeedConfirmBooking, isOpen;
    return _regeneratorRuntime().wrap(function _callee2$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)((0, _actions.register)(_constants2.BOOKING_PROCESS_UI, {
            loading: true
          }));
        case 2:
          _context4.next = 4;
          return (0, _effects.call)(onShowBookingModal, bookingEntity, queryID);
        case 4:
          _context4.next = 6;
          return (0, _effects.select)(_selectors4.getBootstrapOffer);
        case 6:
          offer = _context4.sent;
          _context4.next = 9;
          return (0, _effects.select)(_selectors4.getBookingOperator);
        case 9:
          _yield$select = _context4.sent;
          hasOwnBookingServices = _yield$select.hasOwnBookingServices;
          _context4.next = 13;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQueryParam)(state, {
              paramName: _fn.QUERY_PARAMS.CURRENCY,
              queryID: queryID
            });
          });
        case 13:
          currencyCode = _context4.sent;
          if (!hasOwnBookingServices) {
            _context4.next = 17;
            break;
          }
          _context4.next = 17;
          return (0, _effects.call)(applyExternalActiveBookingServices, queryID, offer.id, currencyCode, bookingEntity);
        case 17:
          if (!hasOwnBookingServices) {
            _context4.next = 23;
            break;
          }
          _context4.next = 20;
          return (0, _effects.select)(function (state) {
            return (0, _BookingResultModal.getIsPriceChanged)(state, {
              currencyCode: currencyCode,
              price: offer.price[currencyCode]
            });
          });
        case 20:
          _context4.t0 = _context4.sent;
          _context4.next = 24;
          break;
        case 23:
          _context4.t0 = false;
        case 24:
          isNeedConfirmBooking = _context4.t0;
          if (isNeedConfirmBooking) {
            _context4.next = 28;
            break;
          }
          _context4.next = 28;
          return (0, _effects.put)((0, _actions2.bookingOfferByOperator)(bookingEntity, queryID));
        case 28:
          _context4.next = 30;
          return (0, _effects.select)(function (state) {
            return (0, _selectors3.isOpen)()(state, {
              key: _BookingResultModal.BOOKING_RESULT_MODAL_KEY
            });
          });
        case 30:
          isOpen = _context4.sent;
          if (isOpen) {
            _context4.next = 34;
            break;
          }
          _context4.next = 34;
          return (0, _effects.call)(onShowBookingModal, bookingEntity, queryID);
        case 34:
          _context4.next = 36;
          return (0, _effects.put)((0, _actions.register)(_constants2.BOOKING_PROCESS_UI, {
            loading: false,
            completed: true
          }));
        case 36:
        case "end":
          return _context4.stop();
      }
    }, _callee2);
  })();
}
function recognizePassportSaga(_ref3) {
  var _ref3$payload = _ref3.payload,
    passport = _ref3$payload.passport,
    onSuccess = _ref3$payload.onSuccess,
    uiKey = _ref3$payload.uiKey;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var callback, recognizedPassport, errorMsg;
    return _regeneratorRuntime().wrap(function _callee3$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          callback = (0, _config.getOnRecognizePassport)();
          if (!callback) {
            _context5.next = 22;
            break;
          }
          _context5.prev = 2;
          _context5.next = 5;
          return (0, _effects.put)((0, _actions.register)(uiKey, {
            loading: true
          }));
        case 5:
          _context5.next = 7;
          return (0, _effects.call)(callback, passport);
        case 7:
          recognizedPassport = _context5.sent;
          onSuccess(recognizedPassport);
          _context5.next = 18;
          break;
        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          _context5.next = 15;
          return (0, _effects.call)(_api.getErrorMessage, _context5.t0);
        case 15:
          errorMsg = _context5.sent;
          _context5.next = 18;
          return (0, _effects.put)((0, _actions.update)(uiKey, {
            error: true,
            message: errorMsg
          }));
        case 18:
          _context5.prev = 18;
          _context5.next = 21;
          return (0, _effects.put)((0, _actions.update)(uiKey, {
            loading: false,
            completed: true
          }));
        case 21:
          return _context5.finish(18);
        case 22:
        case "end":
          return _context5.stop();
      }
    }, _callee3, null, [[2, 11, 18, 22]]);
  })();
}
function bookingOfferByOperatorRootSaga() {
  return _regeneratorRuntime().wrap(function bookingOfferByOperatorRootSaga$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _context6.next = 2;
        return (0, _effects.takeEvery)(_actions2.bookingOfferByOperator, bookingOfferByOperatorSaga);
      case 2:
        _context6.next = 4;
        return (0, _effects.takeEvery)(_actions3.recognizePassport, recognizePassportSaga);
      case 4:
        _context6.next = 6;
        return (0, _effects.takeEvery)(_actions3.startBooking, onStartBookingSaga);
      case 6:
      case "end":
        return _context6.stop();
    }
  }, _marked3);
}